import { AddCircle } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAddContentToPlaylist } from '~/api/playlists/add-content';
import { AddContentDialog, type AddContentSelection } from './dialog';

export interface AddContentButtonProps {
  playlistId: number;
  title?: string;
}

export const AddContentButton = ({ playlistId, title }: AddContentButtonProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const [addContentToPlaylist, { loading }] = useAddContentToPlaylist();

  const displayTitle = title ?? t('components.playlist_detail_page.add_content_button');

  const handleChange = useCallback(
    ({ contentItemIds, mediaItemIds }: AddContentSelection) => {
      void addContentToPlaylist({
        variables: {
          input: { contentItemIds, mediaItemIds, playlistId },
        },
        onCompleted: () => setOpen(false),
      });
    },
    [addContentToPlaylist, playlistId],
  );

  return (
    <>
      <Button
        color="primary"
        onClick={() => setOpen(() => true)}
        startIcon={<AddCircle />}
        variant="contained"
      >
        {displayTitle}
      </Button>

      <AddContentDialog
        introText={t('components.playlist_detail_page.add_content_dialog_intro')}
        loading={loading}
        open={open}
        onClose={() => setOpen(false)}
        onChange={handleChange}
      />
    </>
  );
};
